<template>
  <div class="engine-data-alert-summary">
    <div id="container">
      <recycle-scroller
        :items="alertList"
        v-slot="{ item:alert }"
        key-field="id"
        :min-item-size="80"
        class="sdf-recycle-scroller"
      >
        <div class="row">
          <div class="column-check">
            <vs-checkbox
              v-model="engineCheckedChannels"
              :vs-value="alert.channelId"
              :color="sdfColor.Blue"
              v-if="alert.channelId"
            ></vs-checkbox>
          </div>
          <div class="column-date sdf-text-20-400-red">
            {{displayAlertOccurTime(alert)}}
          </div>
          <div class="column-id sdf-text-20-400-red">
            {{alert.channelId}}
          </div>
          <div class="column-alert-name sdf-text-20-400-red">
            {{alert.channelName}}
          </div>
        </div>
      </recycle-scroller>
    </div>
    <sdf-popup class="display-3d-popup" :popupActive.sync="popupActive">
      <template v-slot:title>
        <feather-icon
          icon="ApertureIcon"
          svgClasses="h-6 w-6"
          class="mr-2 menu-item-icon"
        />
        <p class="popup-title sdf-text-20-400-white">機関室警告3D表示</p>
      </template>
      <vs-input
        v-model="inputChannelNumber"
        class="popup-input"
        placeholder="CH Noを入力"
      ></vs-input>
      <vs-button
        class="popup-button sdf-text-18-400-white"
        :color="sdfColor.Blue"
        :style="popupButtonStyle"
        @click="downloadAlert()"
      >ダウンロード
      </vs-button>
      <vs-button
        class="popup-button sdf-text-18-400-white"
        :color="sdfColor.MouseGray"
        :style="popupButtonStyle"
        @click="popupActive = false"
      >3D表示する
      </vs-button>
    </sdf-popup>
  </div>
</template>

<script>
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import SecureDataflowService from "@/services/secureDataflowService";
import { createNamespacedHelpers } from "vuex";
import SdfPopup from "../../components/SdfPopup"
import {ChannelDataUtil} from "@/utils/secure-dataflow"
import _ from "lodash";
import moment from "moment";
const { mapGetters, mapState, mapActions } = createNamespacedHelpers(
  "monitoringVesselEngine"
);
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

// mixins
import {
  ColorMixin,
  MappingTableMixin,
  StoreMenuMixin,
  StoreCommonsMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  name: "engineDataAlertSummary",
  mixins: [SecureDataflowMixin, StoreMonitoringVesselManeuveringMixin, ColorMixin, MappingTableMixin,StoreMenuMixin,StoreCommonsMixin],
  components: {
    SdfPopup,
    RecycleScroller,
  },
  data() {
    return {
      currentPage: 1,
      engineCheckedChannels: [],
      aiseaAlertCheckedChannels: [],
      inputChannelNumber: "",
      popupActive: false,
      popupButtonStyle: `
        padding: 5px !important;
        margin-right: 15px;
      `,

      beforeAlertList: [],
      alertList: [],
      alertListObj: null,

      hasCalledAlertHistory: false
    }
  },
  watch: {
    channelDataEngine: {
      handler: _.debounce(function () {
        this.crateAlertList()
      }, 1000),
      deep: true
    },
    alertList(value) {
      this.$emit("updateAlertLength", value.length)
    },
    connectingState4gVSAT: {
      handler: _.debounce(function (val) {
        if (val === null) return
        if (val.isDisconnect) {
          let data = {
            id: 1,
            channelId: null,
            channelName: "4G/VSAT 両系切断",
            localTime: val.localTime.format("YYYY/MM/DD HH:mm:ss")
          };
          let index = this.alertList.findIndex((v) => v.id === 1);
          if (index !== -1) {
            this.alertList.splice(index, 1, data);
          } else {
            this.alertList.unshift(data)
          }
        } else {
          let index = this.alertList.findIndex((v) => v.id === 1);
          if (index !== -1) {
            this.alertList.splice(index, 1);
          }
        }
      }, 3000),
      deep: true
    },
    connectingStateSBX: {
      handler: _.debounce(function (val) {
        if (val === null) return
        if (val.isDisconnect) {
          let data = {
            id: 2,
            channelId: null,
            channelName: "SB-X データ不到達",
            localTime: val.localTime.format("YYYY/MM/DD HH:mm:ss")
          };
          let index = this.alertList.findIndex((v) => v.id === 2);
          if (index !== -1) {
            this.alertList.splice(index, 1, data);
          } else {
            this.alertList.unshift(data)
          }
        } else {
          let index = this.alertList.findIndex((v) => v.id === 2);
          if (index !== -1) {
            this.alertList.splice(index, 1);
          }
        }
      }, 3000),
      deep: true
    },
    connectingStateAMS: {
      handler: _.debounce(function (val) {
        if (val === null) return
        if (val.isDisconnect) {
          let data = {
            id: 3,
            channelId: null,
            channelName: "AMS データ不到達",
            localTime: val.localTime.format("YYYY/MM/DD HH:mm:ss")
          };
          let index = this.alertList.findIndex((v) => v.id === 3);
          if (index !== -1) {
            this.alertList.splice(index, 1, data);
          } else {
            this.alertList.unshift(data)
          }
        } else {
          let index = this.alertList.findIndex((v) => v.id === 3);
          if (index !== -1) {
            this.alertList.splice(index, 1);
          }
        }
      }, 3000),
      deep: true
    },
  },
  computed: {
    ...mapGetters(["getCustomChannelIds", "getChannelGroupData", "getVersion", "getAlertSummaryData"]),
    ...mapState({
      alertOccurTimeMap: state => state.alertOccurTimeMap
    }),
    checkedChannels() {
      return {
        engine: this.engineCheckedChannels,
        aisea_alert: this.aiseaAlertCheckedChannels,
      }
    },
    alertLength() {
      return this.alertList.length
    },
    isDisconnect4gVSAT() {
      return this.connectingState4gVSAT !== null && this.connectingState4gVSAT.isDisconnect;
    },
    isDisconnectSBX() {
      return this.connectingStateSBX !== null && this.connectingStateSBX.isDisconnect;
    },
    isDisconnectAMS() {
      return this.connectingStateAMS !== null && this.connectingStateAMS.isDisconnect;
    }
  },
  methods: {
    openLoading(){
      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.sdfColor.Blue,
        container: '#content-area',
      })
      setTimeout( ()=> {
        this.$vs.loading.close('#content-area > .con-vs-loading')
      }, 2000);
    },
    downloadAlert() {
      this.inputChannelNumber = "";
      this.popupActive = false;
    },
    checkAll () {
      let engineChecked = [];
      let aiseaAlertChecked = [];
      this.alertList.forEach((channel) => {
        if (channel.channelId && !_.includes(engineChecked, channel.channelId)) {
          engineChecked.push(channel.channelId);
        }
      })
      this.engineCheckedChannels = _.uniq(engineChecked);
      this.aiseaAlertCheckedChannels = _.uniq(aiseaAlertChecked);
    },
    checkClear () {
      this.engineCheckedChannels = [];
      this.aiseaAlertCheckedChannels = [];
    },

    crateAlertList() {
      let channelDataEngine = this.getAlertList
      if (channelDataEngine) {
        let newAlertList = []
        Object.keys(channelDataEngine).forEach(async k => {
          if (ChannelDataUtil.isAbnormalMachinery(channelDataEngine[k].status)) {
            let channelInfo = await SecureDataflowService.getChannelInfo(channelDataEngine[k].ch);
            if (channelInfo) {
              let data = {
                id: channelDataEngine[k].ch,
                channelId: channelInfo.channel_id,
                channelName: channelInfo.channel_name,
                localTime: moment(channelDataEngine[k].timestamp)
                  .local()
                  .format("YYYY/MM/DD HH:mm:ss")
              };

              // 最初にfirestoreからのアラートが検知できた時から5秒後に発生時間をAPIから取得
              if (!this.hasCalledAlertHistory) {
                this.prepareCallAlertHistory()
                this.hasCalledAlertHistory = true
              }

              // let index = this.alertList.findIndex((v) => v.id === channelDataEngine[k].ch);
              // if(index !== -1){
              //   this.alertList.splice(index, 1, data);
              // } else {
              //   this.alertList.unshift(data)
              // }
              newAlertList.push(data)
            }
          }
        })

        const disconnect_alerts = this.alertList.filter(
          (alert) =>
            (alert.id === 2 && this.isDisconnectSBX) ||
            (alert.id === 3 && this.isDisconnectAMS) ||
            (alert.id === 1 && this.isDisconnect4gVSAT)
        );
        newAlertList.splice(0, 0, ...disconnect_alerts);

        this.alertList.splice(0, this.alertList)
        this.alertList = newAlertList;

      }
    },
    displayAlertOccurTime(alert) {
      if (alert.channelId) {
        if (this.alertOccurTimeMap[alert.channelId]) {
          return this.alertOccurTimeMap[alert.channelId]
        } else {
          return "取得中"
        }
      } else {
        return alert.localTime
      }
    },
    prepareCallAlertHistory() {
      setTimeout( ()=> {
        this.$emit("initialiseAlertHistory")
      }, 5000);
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
.engine-data-alert-summary {
  width: 100%;
  background-color: $dark-blue-navy;
  .row {
    display: flex;
    height: 80px;
    align-items: center;
    border-bottom: solid 0.5px $gray;
  }
  .column-check {
    padding-left: 13px !important;
  }

  .button-3d {
    padding: 0px 13px !important;
    border-radius: 15px;
  }
  .popup-input {
    margin-top: 30px;
    margin-bottom: 30px;
    input {
      background: transparent;
      border-color: $white !important;
    }
    .vs-input--placeholder {
      color: $white;
    }
  }
  .popup-title {
    margin-left: 30px;
  }
  .popup-button {
    padding: 5px !important;
  }
  .sdf-popup-container {
    width: 300px;
  }
  .sdf-recycle-scroller {
    overflow-y: auto;
    height: calc(100vh - 185px);
  }
}
</style>
